//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-classes */
/* eslint-disable functional/no-this-expressions */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
// ReSharper disable InconsistentNaming



export class UserFileData implements IUserFileData {
    userFileId!: string;
    convertedFileName!: string;
    originalFile?: OriginalFile;
    created?: Date | undefined;
    fileType!: StorageType;
    fileVersions!: FileVersion[];
    status!: FileConversionStatus;

    constructor(data?: IUserFileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fileVersions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userFileId = _data["UserFileId"];
            this.convertedFileName = _data["ConvertedFileName"];
            this.originalFile = _data["OriginalFile"] ? OriginalFile.fromJS(_data["OriginalFile"]) : <any>undefined;
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            this.fileType = _data["FileType"];
            if (Array.isArray(_data["FileVersions"])) {
                this.fileVersions = [] as any;
                for (let item of _data["FileVersions"])
                    this.fileVersions!.push(FileVersion.fromJS(item));
            }
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): UserFileData {
        data = typeof data === 'object' ? data : {};
        let result = new UserFileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserFileId"] = this.userFileId;
        data["ConvertedFileName"] = this.convertedFileName;
        data["OriginalFile"] = this.originalFile ? this.originalFile.toJSON() : <any>undefined;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["FileType"] = this.fileType;
        if (Array.isArray(this.fileVersions)) {
            data["FileVersions"] = [];
            for (let item of this.fileVersions)
                data["FileVersions"].push(item.toJSON());
        }
        data["Status"] = this.status;
        return data;
    }
}

export interface IUserFileData {
    userFileId: string;
    convertedFileName: string;
    originalFile?: OriginalFile;
    created?: Date | undefined;
    fileType: StorageType;
    fileVersions: FileVersion[];
    status: FileConversionStatus;
}

export class OriginalFile implements IOriginalFile {
    originalFileName!: string;
    size!: number;

    constructor(data?: IOriginalFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalFileName = _data["OriginalFileName"];
            this.size = _data["Size"];
        }
    }

    static fromJS(data: any): OriginalFile {
        data = typeof data === 'object' ? data : {};
        let result = new OriginalFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OriginalFileName"] = this.originalFileName;
        data["Size"] = this.size;
        return data;
    }
}

export interface IOriginalFile {
    originalFileName: string;
    size: number;
}

export class FileVersion implements IFileVersion {
    version!: string;
    size!: number;
    md5!: string;
    /** Full path for the file in Azure Storage. Should only be used by the legacy API to support Launcher and will be removed in the future */
    storagePath!: string;
    /** Should only be used by the legacy API to support Launcher and will be removed in the future */
    created?: Date;
    /** Should only be used by the legacy API to support Launcher and will be removed in the future */
    modified?: Date;

    constructor(data?: IFileVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["Version"];
            this.size = _data["Size"];
            this.md5 = _data["Md5"];
            this.storagePath = _data["StoragePath"];
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            this.modified = _data["Modified"] ? new Date(_data["Modified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileVersion {
        data = typeof data === 'object' ? data : {};
        let result = new FileVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Version"] = this.version;
        data["Size"] = this.size;
        data["Md5"] = this.md5;
        data["StoragePath"] = this.storagePath;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["Modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileVersion {
    version: string;
    size: number;
    md5: string;
    /** Full path for the file in Azure Storage. Should only be used by the legacy API to support Launcher and will be removed in the future */
    storagePath: string;
    /** Should only be used by the legacy API to support Launcher and will be removed in the future */
    created?: Date;
    /** Should only be used by the legacy API to support Launcher and will be removed in the future */
    modified?: Date;
}

export class FileStatusData implements IFileStatusData {
    id!: string;
    status!: FileConversionStatus;

    constructor(data?: IFileStatusData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): FileStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new FileStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Status"] = this.status;
        return data;
    }
}

export interface IFileStatusData {
    id: string;
    status: FileConversionStatus;
}

export class QueuedFileData implements IQueuedFileData {
    id!: string;

    constructor(data?: IQueuedFileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): QueuedFileData {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedFileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        return data;
    }
}

export interface IQueuedFileData {
    id: string;
}

export enum FileConversionStatus {
    Processing = "Processing",
    Converted = "Converted",
    PartiallyConverted = "PartiallyConverted",
    Failed = "Failed",
}

/** Information about the uploaded file that should be converted */
export class UploadedFileData implements IUploadedFileData {
    filename!: string;

    constructor(data?: IUploadedFileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["Filename"];
        }
    }

    static fromJS(data: any): UploadedFileData {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filename"] = this.filename;
        return data;
    }
}

/** Information about the uploaded file that should be converted */
export interface IUploadedFileData {
    filename: string;
}

/** Type of the file */
export enum StorageType {
    Personal = "Personal",
    Company = "Company",
    Sample = "Sample",
}

export class JsonFileWithoutId implements IJsonFileWithoutId {
    jsonFileId?: string;
    filename!: string;
    content!: string;
    category?: string;
    description?: string;

    constructor(data?: IJsonFileWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonFileId = _data["JsonFileId"];
            this.filename = _data["Filename"];
            this.content = _data["Content"];
            this.category = _data["Category"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): JsonFileWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new JsonFileWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JsonFileId"] = this.jsonFileId;
        data["Filename"] = this.filename;
        data["Content"] = this.content;
        data["Category"] = this.category;
        data["Description"] = this.description;
        return data;
    }
}

export interface IJsonFileWithoutId {
    jsonFileId?: string;
    filename: string;
    content: string;
    category?: string;
    description?: string;
}

export class JsonFile extends JsonFileWithoutId implements IJsonFile {
    jsonFileId!: string;

    constructor(data?: IJsonFile) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jsonFileId = _data["JsonFileId"];
        }
    }

    static fromJS(data: any): JsonFile {
        data = typeof data === 'object' ? data : {};
        let result = new JsonFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JsonFileId"] = this.jsonFileId;
        super.toJSON(data);
        return data;
    }
}

export interface IJsonFile extends IJsonFileWithoutId {
    jsonFileId: string;
}

export class ReplayForUpdate implements IReplayForUpdate {
    replayCategory!: ReplayCategory;
    replayAvailability!: ReplayAvailability;
    language!: string;
    friendlyName!: string;
    description!: string;

    constructor(data?: IReplayForUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.replayCategory = _data["ReplayCategory"];
            this.replayAvailability = _data["ReplayAvailability"];
            this.language = _data["Language"];
            this.friendlyName = _data["FriendlyName"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): ReplayForUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ReplayForUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReplayCategory"] = this.replayCategory;
        data["ReplayAvailability"] = this.replayAvailability;
        data["Language"] = this.language;
        data["FriendlyName"] = this.friendlyName;
        data["Description"] = this.description;
        return data;
    }
}

export interface IReplayForUpdate {
    replayCategory: ReplayCategory;
    replayAvailability: ReplayAvailability;
    language: string;
    friendlyName: string;
    description: string;
}

export class ReplayWithoutId extends ReplayForUpdate implements IReplayWithoutId {
    fileName!: string;
    replayName!: string;
    creatorId!: string;
    companyId!: string;
    replayType!: ReplayType;
    roomMetadataId!: string;
    version!: number;
    timestamp!: number;
    /** duration in milliseconds */
    duration!: number;

    [key: string]: any;

    constructor(data?: IReplayWithoutId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["FileName"];
            this.replayName = _data["ReplayName"];
            this.creatorId = _data["CreatorId"];
            this.companyId = _data["CompanyId"];
            this.replayType = _data["ReplayType"];
            this.roomMetadataId = _data["RoomMetadataId"];
            this.version = _data["Version"];
            this.timestamp = _data["Timestamp"];
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): ReplayWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new ReplayWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["FileName"] = this.fileName;
        data["ReplayName"] = this.replayName;
        data["CreatorId"] = this.creatorId;
        data["CompanyId"] = this.companyId;
        data["ReplayType"] = this.replayType;
        data["RoomMetadataId"] = this.roomMetadataId;
        data["Version"] = this.version;
        data["Timestamp"] = this.timestamp;
        data["Duration"] = this.duration;
        super.toJSON(data);
        return data;
    }
}

export interface IReplayWithoutId extends IReplayForUpdate {
    fileName: string;
    replayName: string;
    creatorId: string;
    companyId: string;
    replayType: ReplayType;
    roomMetadataId: string;
    version: number;
    timestamp: number;
    /** duration in milliseconds */
    duration: number;

    [key: string]: any;
}

export class Replay extends ReplayWithoutId implements IReplay {
    replayId!: string;
    isApproved!: boolean;

    [key: string]: any;

    constructor(data?: IReplay) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.replayId = _data["ReplayId"];
            this.isApproved = _data["IsApproved"];
        }
    }

    static fromJS(data: any): Replay {
        data = typeof data === 'object' ? data : {};
        let result = new Replay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ReplayId"] = this.replayId;
        data["IsApproved"] = this.isApproved;
        super.toJSON(data);
        return data;
    }
}

export interface IReplay extends IReplayWithoutId {
    replayId: string;
    isApproved: boolean;

    [key: string]: any;
}

export class ReplayToCreate implements IReplayToCreate {
    replayWithoutId!: ReplayWithoutId;
    sharedFiles!: SharedFile[];

    constructor(data?: IReplayToCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.replayWithoutId = new ReplayWithoutId();
            this.sharedFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.replayWithoutId = _data["ReplayWithoutId"] ? ReplayWithoutId.fromJS(_data["ReplayWithoutId"]) : new ReplayWithoutId();
            if (Array.isArray(_data["SharedFiles"])) {
                this.sharedFiles = [] as any;
                for (let item of _data["SharedFiles"])
                    this.sharedFiles!.push(SharedFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReplayToCreate {
        data = typeof data === 'object' ? data : {};
        let result = new ReplayToCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReplayWithoutId"] = this.replayWithoutId ? this.replayWithoutId.toJSON() : <any>undefined;
        if (Array.isArray(this.sharedFiles)) {
            data["SharedFiles"] = [];
            for (let item of this.sharedFiles)
                data["SharedFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReplayToCreate {
    replayWithoutId: ReplayWithoutId;
    sharedFiles: SharedFile[];
}

export enum ReplayType {
    Internal = "Internal",
    Custom = "Custom",
    Plugin = "Plugin",
}

export enum ReplayCategory {
    Other = "Other",
    Sales = "Sales",
    Training = "Training",
}

export enum ReplayAvailability {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export enum ReviewStatus {
    Pending = "Pending",
}

export enum Review {
    Approved = "Approved",
    Rejected = "Rejected",
}

export class SharedFile implements ISharedFile {
    fileName!: string;
    storageType!: StorageType;
    userId!: string;
    userCompanyId!: string;

    constructor(data?: ISharedFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.storageType = _data["StorageType"];
            this.userId = _data["UserId"];
            this.userCompanyId = _data["UserCompanyId"];
        }
    }

    static fromJS(data: any): SharedFile {
        data = typeof data === 'object' ? data : {};
        let result = new SharedFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["StorageType"] = this.storageType;
        data["UserId"] = this.userId;
        data["UserCompanyId"] = this.userCompanyId;
        return data;
    }
}

export interface ISharedFile {
    fileName: string;
    storageType: StorageType;
    userId: string;
    userCompanyId: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}